import { Icon, Input } from "@elaniintc/goes-design-system";
import { useState } from "react";
import type { ComponentProps } from "react";

interface Props extends ComponentProps<typeof Input> {
  label: string;
  required?: boolean;
  error?: string;
}

export const PasswordField = ({ label, required = false, ...props }: Props) => {
  const [passwordVisible, setPasswordVisible] = useState<"hidden" | "visible">(
    "hidden",
  );

  const inputType = passwordVisible === "visible" ? "text" : "password";

  return (
    <div className="flex flex-col gap-1">
      <label
        className="font-semibold text-body-loud text-sm leading-2xl"
        htmlFor={props.id || props.name}
      >
        {label}
        {required && <span className="text-sm text-danger">*</span>}
      </label>
      <div className="w-full relative">
        <Input {...props} className="w-full pr-10" type={inputType} />
        <button
          type="button"
          className="absolute size-5 text-lg right-3 top-1/2 -translate-y-1/2 cursor-pointer bg-fore flex items-center justify-center"
          onClick={() => {
            setPasswordVisible(
              "visible" === passwordVisible ? "hidden" : "visible",
            );
          }}
        >
          <Icon
            type="far"
            name={passwordVisible === "visible" ? "eye-slash" : "eye"}
            className="text-body text-sm leading-3xl"
          />
        </button>
      </div>
      {props.error && (
        <div className="text-danger flex items-center gap-1.5">
          <Icon
            type="far"
            name="circle-xmark"
            className="text-current text-xs"
          />
          <span className="text-current text-xs leading-xl font-normal">
            {props.error}
          </span>
        </div>
      )}
    </div>
  );
};
